import type {Thread} from '@github-ui/diff-lines/conversation-types'

export function isThreadOutdated(thread: Thread): boolean {
  return thread.isOutdated || thread.subject?.isOutdated || thread.positioning?.isOutdated || false
}
